// extracted by mini-css-extract-plugin
export default {"Image":"PageNotFound_Image__sE22X","Container":"PageNotFound_Container__Hj5WZ"};